import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Landing from "@/pages/Landing";
import GamingPage from "@/pages/GamingPage";
import YouTubePage from "@/pages/YouTubePage";
import KidsPage from "@/pages/KidsPage";
import AboutPage from "@/pages/AboutPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/gaming" element={<GamingPage />} />
          <Route path="/youtube" element={<YouTubePage />} />
          <Route path="/kids" element={<KidsPage />} />
          <Route path="/about" element={<AboutPage />} />
        </Routes>
        <Footer />
        <Toaster
          position="top-right"
          richColors
          toastOptions={{
            style: {
              fontFamily: "'Work Sans', sans-serif",
              borderRadius: "14px",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
